import TextLink from '@allesauto/core/textLink';
import { FieldTypeLink, getUrlFromStoryblokLink } from '@allesauto/utils/funcs';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';

interface Column {
  _uid: string;
  headline: string;
  component: string;
  links: {
    url: any;
    _uid: string;
    text: string;
    component: string;
  }[];
}

interface BrandModelsListingProps {
  headline: string;
  description?: string;
  linkText?: string;
  link: FieldTypeLink;
  _uid: string;
  component: string;
  columns: Column[];
}

const cssClasses = {
  container: clsx('bg-white px-40px py-60px'),
  titleContainer: clsx('flex items-center justify-between mb-[24px]'),
  desktopLink: clsx('hidden lg:flex'),
  mobileLink: clsx('flex mt-20px lg:hidden'),
  columnsContainer: clsx(
    'gap-y-[24px] grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6',
    'mt-20px'
  ),
  columnLinksContainer: 'flex flex-col',
  columnLinkItem: clsx('mt-[8px]'),
  brand: clsx('mb-[8px]'),
};

const BrandModelsListing = (props: BrandModelsListingProps) => {
  const { headline, description, link, linkText, columns } = props;
  const showTopLink = link && linkText;

  const linkHref = getUrlFromStoryblokLink(link);

  return (
    <section className={cssClasses.container} {...sbEditable(props)}>
      <div className={cssClasses.titleContainer}>
        <h3>{headline}</h3>
        {showTopLink && (
          <TextLink
            text={linkText}
            href={linkHref}
            customClassName={cssClasses.desktopLink}
          />
        )}
      </div>
      {description && <p>{description}</p>}
      <div className={cssClasses.columnsContainer}>
        {columns.map((column) => (
          <div key={column._uid}>
            <p className={cssClasses.brand}>{column.headline}</p>
            <div className={cssClasses.columnLinksContainer}>
              {column.links.map((link) => (
                <TextLink
                  key={link._uid}
                  noUnderline
                  icon={null}
                  text={link.text}
                  href={getUrlFromStoryblokLink(link.url)}
                  textColor="text-grey50 monochrome:text-grey50 hover:text-grey80"
                  customClassName={cssClasses.columnLinkItem}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
      {showTopLink && (
        <TextLink
          text={linkText}
          href={linkHref}
          customClassName={cssClasses.mobileLink}
        />
      )}
    </section>
  );
};

export default BrandModelsListing;
